export enum ConfirmEmailErrorCodes {
  EmailTokenExpired = 400
}
